export default "__VITE_ASSET__CXJMkxJJ__"